import React, { useEffect, useState } from 'react'
import { Layout } from 'antd'
import PageTitle from './overview/PageTitle'
import Header from './Header'
import ApiDocsContent from './ApiDocsContent'

export type TabType = 'home' | 'openApi' | 'zapier' | 'contact';

const ApiDoc = () => {
    const { Content } = Layout
    const HEADER_HEIGHT = 72


    //  default landing view
    const [activeTab, setActiveTab] = useState<'home' | 'openApi' | 'zapier' | 'contact'>('home')


    // Persist tab changes
    const handleTabChange = (tab: any) => {
        setActiveTab(tab);
    };


    return (
        <Layout style={{ backgroundColor: '#FFF4ED' }}>
            <Header activeTab={activeTab} setActiveTab={handleTabChange} />

            <Content
                style={{
                    padding: '20px',
                    maxWidth: '1140px',
                    width: '100%',
                    margin: '0 auto',
                    paddingTop: `calc(20px + ${HEADER_HEIGHT}px)`,
                }}
            >
                <div className="contentBody-api">
                    <div className="bodycard">

                        {/* 🔹 Show only on HOME */}
                        {activeTab === 'home' && (
                            <>
                                <PageTitle
                                    pagTitle=""
                                    button={false}
                                    setActiveTab={handleTabChange}   // 👈 pass this
                                    activeTab={activeTab}
                                />
                            </>
                        )}

                        <ApiDocsContent activeTab={activeTab} setActiveTab={handleTabChange}
/>

                    </div>
                </div>
            </Content>
        </Layout>
    )
}

export default ApiDoc

